import { parseControlDiff } from "../../../../lib/controlDiffUtils";
import { ScalarFieldDiffRow } from "./ScalarFieldDiffRow";
import { ArraySectionDiff } from "./ArraySectionDiff";

interface ControlChangeDiffProps {
  changeDiff: Record<string, unknown>;
}

export function ControlChangeDiff({ changeDiff }: ControlChangeDiffProps) {
  const { scalarChanges, sectionChanges } = parseControlDiff(changeDiff);

  if (scalarChanges.length === 0 && sectionChanges.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold">Proposed Changes</h3>

      {scalarChanges.length > 0 && (
        <div className="border border-stone-200 rounded-md overflow-hidden">
          {scalarChanges.map((change) => (
            <ScalarFieldDiffRow
              key={change.field}
              field={change.field}
              oldValue={change.oldValue}
              newValue={change.newValue}
            />
          ))}
        </div>
      )}

      {sectionChanges.map((section) => (
        <ArraySectionDiff
          key={section.field}
          field={section.field}
          oldItems={section.oldItems}
          newItems={section.newItems}
        />
      ))}
    </div>
  );
}
